import React from "react";
import { Card, Flex, List, Stack, Text } from "@chakra-ui/react";
import { Button } from "../../components/ui/button";
import { useModalState } from "../../helpers/ModalProvider";

const DangerZoneSection: React.FC = () => {
  const { showDeleteAccountModal } = useModalState();

  return (
    <Card.Root borderColor="#fecaca" borderWidth="1px">
      <Card.Header>
        <Card.Title fontSize="30px" fontWeight="bold" letterSpacing="-0.4px" lineHeight="32px" color="#dc2626">
          Danger Zone
        </Card.Title>
        <Card.Description fontSize="md" color="#52525b" lineHeight="24px">
          Permanently delete your account and all associated data.
        </Card.Description>
      </Card.Header>
      <Card.Body>
        <Stack gap={3}>
          <Text fontSize="md" fontWeight="bold" color="#000">
            Delete account
          </Text>
          <Text fontSize="sm" color="#52525b">
            <Text as="span" fontWeight="bold">Danger!</Text> Deleting your account will cause the following:
          </Text>
          <List.Root pl={5} gap={1}>
            <List.Item fontSize="sm" color="#52525b">You will permanently lose all accrued CoinCap points.</List.Item>
            <List.Item fontSize="sm" color="#52525b">You will permanently lose all chat history.</List.Item>
            <List.Item fontSize="sm" color="#52525b">All API keys and API request history will be deleted.</List.Item>
            <List.Item fontSize="sm" color="#52525b">Your active subscription will be canceled and you will not be charged again.</List.Item>
          </List.Root>
          <Text fontSize="sm" fontWeight="bold" color="#000">
            This action cannot be undone.
          </Text>
          <Flex justifyContent="flex-end" mt={2}>
            <Button colorPalette="red" variant="solid" onClick={() => showDeleteAccountModal()}>
              Delete my account
            </Button>
          </Flex>
        </Stack>
      </Card.Body>
    </Card.Root>
  );
};

export default DangerZoneSection;
